import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';
import FormTextArea from './../inputs/textarea';

import FormSelect from './../inputs/select';
import FormDate from './../inputs/date';

import FormSwitch from './../inputs/switch';
import FormFileUpload from "./../inputs/fileupload";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { prepareForm, getLocalizedCountryFromCurrency } from './../../utils';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import moment from 'moment';

const RatesEdit = () => {

    let navigate = useNavigate();
    const { rateStore, utilsStore, countryCurrencyStore } = useStores();
    const { getById, rate, save, reset } = rateStore;
    const { getCountryCurrencies, countryCurrencies } = utilsStore;    

    const { t, i18n } = useTranslation();

    const { id } = useParams();
    const isNew = () => id && id == "new";

    const [isLoading, setIsLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    
    useEffect(() => {
        async function fetchMyAPI() {
            setIsLoading(true);
            Promise.all([getById(id), getCountryCurrencies(true)]).then(() => {
                setIsLoading(false);

            });
        }

        if (id == "new") {
            handleReset();
            getCountryCurrencies(true);
        } else {
            fetchMyAPI();
        }

    }, [getById, reset]);

    const handleSubmit = (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            var formData = prepareForm(event, isNew(), ["id", "quantity", "rate", "currency"]);
            formData.year = Number(formData.period?.split("-")?.[0] ?? 0);
            formData.month = Number(formData.period?.split("-")?.[1] ?? 0);
            
            save(formData, () => { goToList() });
        }

        setValidated(true);
    };

    const handleReset = () => {
        reset();
        setValidated(false);
    };

    const goToList = () => {
        navigate("/administration/rates")
    };

    

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Card>
                <Card.Body>
                    <Stack direction="vertical">
                        <Row>
                            <Col style={{ alignSelf: "center" }}  >
                                <ArrowBackIosIcon sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate("../rates")} size="small" />
                                <b>{t(isNew() ? 'newRate' : 'rate')}  {!isNew() && `(Id: ${id})`}</b>
                            </Col>
                            <Col md="auto"><Button className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button></Col>

                            <Col md="auto"><Button type="submit" className="btn btn-secondary float-end" >{t('save')}</Button></Col>
                        </Row>

                        <hr />

                        
                        <Row className="my-2">
                            <Col xs={2}>
                                <FormText hidden isNumber id="id" type="number" object={rate} />
                                <FormDate required month label={t("period")} id="period" isLoading={isLoading} object={rate} />
                                
                            </Col>
                            <Col xs={2}>
                                {/*<FormText required label={t("currency")} id="currencyCode" isLoading={isLoading} object={rate} />*/}
                                <FormSelect onCreateClick={() => window.open('/administration/country-currencies/new', '_blank')}
                                    required label={t("currency")} id="currencyId"
                                    isLoading={isLoading} object={rate}
                                    items={countryCurrencies?.map((x) => ({ id: x.id, name: `${x.code?.toUpperCase()} - ${getLocalizedCountryFromCurrency(x)}`}))} itemId="id" itemLabel="name"
                                />
                            </Col>

                           
                            {/*<Col xs={2}>

                                <FormText required label={t("symbol")} id="symbol" isLoading={isLoading} object={currency} />
                            </Col>*/}
                        </Row>

                        {/*<Row className="my-2">
                            

                            <Col xs={2}>
                                <FormText required label={t("countryEN")} id="countryEN" isLoading={isLoading} object={rate} />
                            </Col>

                            <Col xs={2}>
                                <FormText required label={t("countryFR")} id="countryFR" isLoading={isLoading} object={rate} />
                            </Col>                            
                        </Row>*/}

                        <Row className="my-2">


                            <Col xs={2}>
                                <FormText useFormattedInput allowDefault decimalScale={0} type="number" onlyDigits required label={t("quantity")} id="quantity" isLoading={isLoading} object={rate} />
                            </Col>

                            <Col xs={2}>
                                <FormText useFormattedInput allowDefault decimalScale={4} type="number" required label={t("rate")} id="rate" isLoading={isLoading} object={rate} />
                            </Col>
                        </Row>

                    </Stack>



                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(RatesEdit);
